module.exports = __webpack_public_path__ + "static/img/产品中心-问煤-标准化作业指导.87eebfc8.jpg";